import { ISeason } from '../store';

import api, { request } from '../../../api';
import { IStore } from '../../index';

export const update = async (
  state: IStore,
  clubId: number,
  seasonId: number,
  data: Partial<ISeason>
) => {
  const response = await request.patch(`${api.admin.season(clubId, seasonId)}`, data);

  if (response.error) {
    return { errors: { seasons: { msg: 'Error fetching club seasons' } } };
  }

  const { seasons } = state.seasons[clubId];

  const seasonIndex = seasons.findIndex(season => season.id === response.id);

  seasons[seasonIndex] = response;

  return {
    seasons: {
      ...state.seasons,
      [clubId]: {
        ...state.seasons[clubId],
        seasons
      }
    }
  };
};
